import { render, staticRenderFns } from "./contenidosDocente.vue?vue&type=template&id=9b40b9da"
import script from "./contenidosDocente.vue?vue&type=script&lang=js"
export * from "./contenidosDocente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports